import React from "react";
import moment from "moment";
import classnames from "classnames";
import { connect } from "react-redux";
import { Field, reduxForm, change } from "redux-form";
import { callService, formatDateDMA, existeFecha } from "../tools";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import '../gnp-registro/gnp-registro-new-movile.css'


var validacioncertificado = false;
var polizaBMX = false;
var polizaBMXreal = null;
var clienteUnico = null;
const validate = values => {
	const errors = {};

	if (!values.poliza1) {
		errors.poliza1 = "Campo requerido.";
	}


	if (!values.certificado) {
		errors.certificado = "Campo requerido.";
	} else if (values.certificado && values.certificado.length != 8) {
		errors.certificado = "Campo requerido de 8 numeros.";
	}


	if (!values.dia || !values.mes || !values.anio) {
		errors.dia = "Campo requerido.";
	} else if (existeFecha(values.dia, values.mes, values.anio) == false) {
		errors.dia = "La fecha inicio de vigencia es inválida. Verifícala e intenta de nuevo.";
	}

	if (!values.rfcbnmx) {
		errors.rfcbnmx = "Campo RFC requerido.";
	} else if (!/^[a-zA-Z0-9_]*$/i.test(values.rfcbnmx)) {
		errors.rfcbnmx = "Este campo sólo acepta números y letras.";
	}

	if (!values.rfcbnmx) {
		errors.rfcbnmx = "Campo requerido.";
	} else if (/^[a-zA-Z]{3,4}(\d{6})((\D|\d){2,3})?$/.test(values.rfcbnmx) == false) {
		errors.rfcbnmx = "Formato de RFC inválido.";
	} else if (values.rfcbnmx && values.diaNacimiento && values.mesNacimiento && values.anioNacimiento) {
		if (values.rfcbnmx.substr("4", "6") != values.anioNacimiento.toString().substr("2", "2") + values.mesNacimiento + values.diaNacimiento) {
			errors.rfcbnmx = "El RFC no coincide con la fecha de nacimiento.";
		}
	}
	return errors;
};

const asyncValidate = (values, dispatch) => {
	values.poliza1 = values.poliza1.replace(/ /g, "").toUpperCase();
	dispatch(change("agregarPoliza", "poliza1", values.poliza1));

	let fecha = false;
	let validacionfecha = "";
	let dia = values.dia;
	let mes = values.mes;
	let anio = values.anio;

	if (dia != "" && mes != "" && anio != "") {
		fecha = dia + "/" + mes + "/" + anio;
		validacionfecha = fecha;
	}

	console.log("FechaD: ", validacionfecha.includes("undefined"));

	dispatch(change("agregarPoliza", "ramo1", ""));

	let certificadoExiste = (document.getElementsByName("certificado")[0] != undefined) ? document.getElementsByName("certificado")[0].value : false;

	if (certificadoExiste && certificadoExiste.length == 8) {
		return new callService({
			service: "crm.polizacertificado",
			secure: true,
			data: { numeroPoliza: limpiar(values.poliza1), certificado: limpiar(certificadoExiste), claveSistema: limpiar(values.sistema) }
		}).execute().then((oResult) => {
			dispatch({ "type": "SET_POLIZA_VALIDA", "valida": true });
		}).catch((error) => {
			dispatch({ "type": "SET_POLIZA_VALIDA", "valida": false });
			throw { certificado: "Certificado invalido" };
		});



	} else if (!certificadoExiste && values.poliza1 && values.poliza1 !== "" && fecha && !validacionfecha.includes("undefined")) {
		dispatch({ "type": "LOADER", "show": true });

		if (values.poliza1.startsWith('CBX') || values.poliza1.startsWith('cbx')) {

			if (values.poliza1.length > 10) {	//Remover 0 despues de CBX4
				values.poliza1 = values.poliza1.slice(0, 4) + values.poliza1.slice(5);
			}
			polizaBMX = true;
		}

		return new callService({
			service: "utilerias.identificaPoliza",
			secure: true,
			data: { poliza: limpiar(values.poliza1), fecha: fecha }
		}).execute().then((oResult) => {
			dispatch({ "type": "LOADER", "show": false });
			dispatch(change("agregarPoliza", "ramo1", oResult.ramo));
			dispatch(change("agregarPoliza", "poliza1", oResult.numPoliza));
			dispatch(change("agregarPoliza", "sistema", oResult.sistema));
			dispatch(change("agregarPoliza", "grupo", oResult.grupo));
			dispatch(change("agregarPoliza", "iniVigenciaDate", values.iniVigenciaDate));
			dispatch(change("agregarPoliza", "iniVigencia", values.iniVigencia));

			if (polizaBMX || polizaBMXreal) {
				polizaBMXreal = oResult.numPoliza;
			} else {
				polizaBMXreal = null;
			}

			if (oResult.grupo) {
				dispatch({ "type": "HOME_SET_EVENT", "evento": "PolizaGrupal" });
			}

			if (oResult.certificado) {
				dispatch({ "type": "SET_MOSTRAR_CERTIFICADO", "mostrar": true });

			} else {
				dispatch({ "type": "SET_MOSTRAR_CERTIFICADO", "mostrar": false });

			}
			dispatch({ "type": "SET_POLIZA_VALIDA", "valida": true });
		}).catch((error) => {
			console.log(error);

			dispatch({ "type": "LOADER", "show": false });
			dispatch({ "type": "SET_POLIZA_VALIDA", "valida": false });
			dispatch({ "type": "SET_MOSTRAR_CERTIFICADO", "mostrar": false });
			dispatch(change("agregarPoliza", "ramo1", ""));
			dispatch(change("agregarPoliza", "certificado", ""));
			dispatch(change("agregarPoliza", "grupo", ""));
			dispatch(change("agregarPoliza", "sistema", ""));
			if (typeof error.message !== "undefined") {
				if (typeof error.message.mensaje === "undefined") {
					throw { poliza1: 'Error desconocido, por favor, intente más tarde.' }
				} else {
					throw { poliza1: error.message.mensaje };
				}
			} else {
				throw { poliza1: 'Error desconocido, por favor, intente más tarde.' }
			}
		});
	} else {
		return new Promise(resolve => resolve());
	}


};

const limpiar = (value) => {
	return (value != undefined) ? value.replace(/\s/g, "").toUpperCase() : "";
};

const mapState = (state) => {
	clienteUnico = state.global.clienteUnico;
	return {
		polizaValida: state.polizas.polizaValida,
		mostrarCertificado: state.polizas.mostrarCertificado,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		esconderCertificado: () => {
			dispatch({ "type": "SET_MOSTRAR_CERTIFICADO", "mostrar": false });
		}
	};
};

const campo = ({ ...custom, name, input, label, max, type, focus, change, meta: { touched, error } }) => {
	return (
		<MuiThemeProvider>
			<TextField
				{...input}
				floatingLabelText={label}
				name={name}
				fullWidth={true}
				underlineStyle={{ borderColor: '#AAC3EE' }}
				underlineFocusStyle={{ borderColor: '#FF6B0B' }}
				floatingLabelStyle={floatingLabelStyleSettings}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				type={type}
				onFocus={focus}
				maxLength={max}
				errorText={touched && error}
			/>
		</MuiThemeProvider>

	);
};

const campoSelect = ({
	input,
	label,
	type,
	blur,
	change,
	name,
	meta: { touched, error },
	children,
	...custom
}) => {
	return (
		<MuiThemeProvider>
			<SelectField
				{...input}
				name={name}
				floatingLabelText={label}
				underlineStyle={{ borderColor: '#AAC3EE' }}
				underlineFocusStyle={{ borderColor: '#FF6B0B' }}
				floatingLabelStyle={floatingLabelStyleSettings}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				onChange={(event, index, value) => { input.onChange(value); change(value); }}
				children={children}
				fullWidth={true}
				errorText={touched && error}
				{...custom}
			/>
		</MuiThemeProvider>
	);
};

const espacios = value => {
	const texto = (value != undefined) ? value.replace(/\s/g, "") : "";
	return texto.toUpperCase();
};

const campoSettings = {
	fontFamily: 'Roboto',
	fontStyle: 'normal',
	fontWeight: 'normal',
	mixBlendMode: 'normal',
}
const floatingLabelStyleSettings = {
	...campoSettings,
	lineHeight: '24px',
	letterSpacing: '0.5px',
	color: '#0C2040',
}
const floatingLabelFocusStyleSettings = {
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.4px',
	color: '#FF6B0B',
}

class PolizaForm extends React.Component {

	componentWillMount = () => {
		polizaBMXreal = null;
		clienteUnico = null;
		let $this = this;
		$(function () {
			$("input.datepicker-input").datepicker({
				format: "dd   -   MM   -   yyyy",
				language: "es",
				endDate: "0d",
				autoclose: true,
				disableTouchKeyboard: true
			}).on("changeDate", $this.handleDateChangeEvent);
		});
	}

	componentWillUnmount = () => {
		this.props.esconderCertificado();
	}

	handleChange = (event) => {
		let fecha = this.getFechaNacimiento();
		if (fecha) {
			this.props.asyncValidate();
		}
	}

	handleChangeSelect = (value) => {
		console.log("Handle Select", value)
		setTimeout(() => {
			let fecha = this.getFechaNacimiento();
			if (fecha) {
				console.log(fecha)
				this.props.asyncValidate();
			}
		}, 1000)
	}

	getFechaNacimiento = () => {
		let dia = this.dia.value;
		let mes = this.mes.value;
		let anio = this.anio.value;

		if (!!dia && !!mes && !!anio) {
			let date = new Date(anio, mes - 1, dia);
			this.props.change("iniVigencia", moment(anio + "-" + mes + "-" + dia, "YYYY-MM-DD").format("DD - MMMM - YYYY"));
			this.props.change("iniVigenciaDate", date.getTime());
			return dia + "/" + mes + "/" + anio;
		} else {
			return false;
		}
	}

	validarCertificado = (oForm) => {
		let $this = this;
		$this.props.loader(true);

		let llamaServicio = new callService({
			service: "utilerias.identificaCertificado",
			secure: true,
			data: { poliza: limpiar(oForm.poliza), certificado: limpiar(oForm.certificado), sistema: $this.props.certificado }
		}).execute().then((oResult) => {
			console.log("Respuesta", oResult);
			$this.props.loader(false);
		}).catch((error) => {
			console.log("Error", error);
			$this.props.loader(false);

		});
	}


	render() {
		const { handleSubmit, submitting } = this.props;

		var margen = classnames({
			"text-content": true,
			"mt-34": !this.props.mobile
		});

		var dias = [], meses = [], anios = [], diasNac = [], mesesNac = [], aniosNac = [];
		for (let i = 1; i <= 31; i++) {
			let dia = (i < 10) ? "0" + i : i;
			dias.push(<MenuItem value={dia} key={i} primaryText={dia} />);
			if (i <= 12) {
				meses.push(<MenuItem value={dia} key={i} primaryText={dia} />);
			}
		}
		for (let i = 1; i <= 31; i++) {
			let diaN = (i < 10) ? "0" + i : i;
			diasNac.push(<MenuItem value={diaN} key={i} primaryText={diaN} />);
			if (i <= 12) {
				mesesNac.push(<MenuItem value={diaN} key={i} primaryText={diaN} />);
			}
		}
		for (let i = new Date().getFullYear(); i >= 1980; i--) {
			anios.push(<MenuItem value={i} key={i} primaryText={i} />)
		}
		for (let i = new Date().getFullYear(); i >= 1920; i--) {
			aniosNac.push(<MenuItem value={i} key={i} primaryText={i} />)
		}
		return (
			<form className="container" onSubmit={handleSubmit}>
				<div className="margin-mobile" >
					<div >
						<div>
							<h5>
								<i className="gnp-material-content-registro-labelTextLectura-AgregarPTitulo">Información de la Póliza</i>
							</h5><br />
							<div className="gnp-material-content-registro-labelTextLectura-AgregarP">
								<p>En esta sección puedes agregar pólizas que no estés visualizando en tu consulta.<br />
									Para solicitarla ingresa los datos que se te piden y da clic en continuar.</p>

							</div>

							<div className="row">
								<div className="col-md-6 col-sm-6 col-xs-12">
									<Field ref={elem => this.noPoliza = elem} name="poliza1" type="text"
										component={campo} normalize={espacios} max="15" label="No. póliza o No. referencia" />
								</div>
								<div >
									<div className="col-md-12 col-sm-12 col-xs-12">
										<label className="gnp-material-label margin-labels">Fecha inicio vigencia de la póliza</label>
									</div>
									<div className="col-md-4 col-sm-4 col-xs-4 select-field-left">
										<Field ref={elem => this.dia = elem} label="día" name="dia"
											component={campoSelect} change={this.handleChangeSelect.bind(this)}>
											{dias}
										</Field>
									</div>
									<div className="col-md-4 col-sm-4 col-xs-4 select-field-center">
										<Field ref={elem => this.mes = elem} name="mes" label="mes"
											component={campoSelect} change={this.handleChangeSelect.bind(this)}>
											{meses}
										</Field>
									</div>
									<div className="col-md-4 col-sm-4 col-xs-4 select-field-right">
										<Field ref={elem => this.anio = elem} name="anio" label="año"
											component={campoSelect} change={this.handleChangeSelect.bind(this)} >
											{anios}
										</Field>
									</div>
								</div>
							</div>
							<div className="select-ramo poliza-input" style={{ "display": "none" }}>
								<p>Ramo</p>
								<Field name="ramo1" component={campoSelect} change={this.handleChangeSelect.bind(this)} disabled={true}>
									<option />
									<option value="A"  >Autos</option>
									<option value="G" >Gastos Médicos Mayores</option>
									<option value="V" >Vida</option>
									<option value="D" >Daños</option>
								</Field>
							</div>
							{this.props.mostrarCertificado &&
								<Field name="certificado" type="text" component={campo}
									label="Certificado" change={this.handleChange.bind(this)} />
							}
							<Field name="iniVigencia" component="input" type="hidden" />
							<Field name="iniVigenciaDate" component="input" type="hidden" />
							<Field name="sistema" component="input" type="hidden" />
							<Field name="grupo" component="input" type="hidden" />
						</div>
					</div>

					{polizaBMXreal && this.props.polizaValida &&
						<div className="row">

							<div className="col-md-12 col-sm-12 col-xs-12">
								<Field name="rfcbnmx" type="text" component={campo}
									change={this.handleChange.bind(this)} normalize={espacios} max="15" label="RFC" />
							</div>
							<div className="col-md-12 col-sm-12 col-xs-12">
								<label className="gnp-material-label margin-labels">Fecha de nacimiento</label>
							</div>
							<div className="col-md-4 col-sm-4 col-xs-4 select-field-left">
								<Field ref={elem => this.diaNacimiento = elem} label="día"
									name="diaNacimiento" component={campoSelect} change={this.handleChangeSelect.bind(this)}>
									{diasNac}
								</Field>
							</div>
							<div className="col-md-4 col-sm-4 col-xs-4 select-field-center">
								<Field ref={elem => this.mesNacimiento = elem} label="mes"
									name="mesNacimiento" component={campoSelect} change={this.handleChangeSelect.bind(this)}>
									{mesesNac}
								</Field>
							</div>
							<div className="col-md-4 col-sm-4 col-xs-4 select-field-right">
								<Field ref={elem => this.anioNacimiento = elem} label="año"
									name="anioNacimiento" component={campoSelect} change={this.handleChangeSelect.bind(this)}>
									{aniosNac}
								</Field>
							</div>
						</div>




					}


					<div className="row">
						<div className="agregar-button-container">
							<div className="col-md-12 col-sm-12 col-xs-12">
								<button type="submit" disabled={!(this.props.polizaValida)}
									className={"pure-material-button-contained btn-full-width " + (this.props.polizaValida ? "" : "disabled")}>Continuar</button>
							</div>
						</div>
					</div>
				</div>


			</form>
		);
	}
}
PolizaForm = reduxForm({
	form: "agregarPoliza",
	validate,
	asyncValidate,
	asyncBlurFields: ["poliza1", "iniVigenciaDate", "iniVigencia"]
})(PolizaForm);

export default connect(mapState, mapDispatch)(PolizaForm);


// WEBPACK FOOTER //
// ./src/home/polizaWebMovil.frm.js